import { languageState } from "state/language";
import { useRecoilValue } from "recoil";

const Error = ({ error }: { error: String }) => {
  const currentLanguage = useRecoilValue(languageState);
  
  // Check if the current URL already contains /404 to prevent endless redirect
  if (window.location.pathname.includes('/404')) {
    window.location.href = '/';
  } else {
    window.location.href = `/${currentLanguage}/404`;
  }
  
  return null;
};

export default Error;
